import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import '../../stylesheets/components/RxCard.scss';
import RxCardSendCoupon from '../RxCard/RxCardSendCoupon';
import { fetchCouponData } from '../../services/Api/Coupon/CouponService';
import {
  WALGREENS,
  WALMART,
  CVS,
  DEFAULT_PARTNER_PID,
  DEFAULT_PARTNER_PASSWORD,
  CVS_PARTNER_PID,
  CVS_PARTNER_PASSWORD,
  WALMART_PARTNER_PID,
  WALMART_PARTNER_PASSWORD,
  RX_CARD_VIEW,
  PHARMACIST_DEFAULT_PARTNER_PID,
  PHARMACIST_DEFAULT_PARTNER_PWD,
  PHARMACIST_WALMART_PARTNER_PID,
  PHARMACIST_WALMART_PARTNER_PWD,
  PHARMACIST_CVS_PARTNER_PID,
  PHARMACIST_CVS_PARTNER_PWD
} from '../../constants/defaults';
import { AuthContext } from '../../Contexts';

class RxCardPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPharmacy: this.props.selectedPharmacy,
      cardImage: null,
      loading: true,
      isNotificationVisible: false,
      notificationFor: ''
    };
  }
  static contextType = AuthContext;
  componentDidMount() {
    let intervalId = setInterval(() => {
      if (this.context?.userData?.isLoggedIn) {
        clearInterval(intervalId);
        this.fetchCardData(this.props.selectedPharmacy);
      }
    }, 200);
  }

  getPharmacyData(cardType) {
    const { isFromPharmacists } = this.props;
    let pharmacy = {
      PartnerUser: isFromPharmacists
        ? PHARMACIST_DEFAULT_PARTNER_PID
        : DEFAULT_PARTNER_PID,
      PartnerPassword: isFromPharmacists
        ? PHARMACIST_DEFAULT_PARTNER_PWD
        : DEFAULT_PARTNER_PASSWORD,
      PharmacyName: cardType
    };
    switch (cardType) {
      case CVS:
        pharmacy.PartnerUser = isFromPharmacists
          ? PHARMACIST_CVS_PARTNER_PID
          : CVS_PARTNER_PID;
        pharmacy.PartnerPassword = isFromPharmacists
          ? PHARMACIST_CVS_PARTNER_PWD
          : CVS_PARTNER_PASSWORD;
        pharmacy.PharmacyName = cardType;
        return pharmacy;
      case WALMART:
        pharmacy.PartnerUser = isFromPharmacists
          ? PHARMACIST_WALMART_PARTNER_PID
          : WALMART_PARTNER_PID;
        pharmacy.PartnerPassword = isFromPharmacists
          ? PHARMACIST_WALMART_PARTNER_PWD
          : WALMART_PARTNER_PASSWORD;
        pharmacy.PharmacyName = cardType;
        return pharmacy;
      case WALGREENS:
      default:
        return pharmacy;
    }
  }

  async fetchCardData(cardType) {
    let selectedPharmacy = this.getPharmacyData(cardType);
    const utmzCookie = _.getCookie('_utmz_custom');
    const utmzCookies = utmzCookie.split('|');
    const source = utmzCookies[2].split('=')[1] || null,
      medium = utmzCookies[1].split('=')[1] || null,
      cgn = utmzCookies[0].split('=')[1] || null;
    let utmParams = {
      src: source,
      med: medium,
      cgn
    };
    try {
      const { PDFUrl } = await fetchCouponData(
        selectedPharmacy.PartnerUser,
        selectedPharmacy.PartnerPassword,
        RX_CARD_VIEW,
        utmParams
      );
      await this.setState({
        cardImage: PDFUrl,
        loading: false,
        selectedPharmacy
      });
    } catch (err) {
      console.log(err.message);
    }
  }

  showNotification(notificationFor = '', showNotificationText) {
    let newState = { apiSuccess: true };
    newState.isNotificationVisible = showNotificationText;
    newState.notificationFor = notificationFor;
    this.setState(newState, () => {
      if (showNotificationText) {
        setTimeout(() => {
          this.setState({ isNotificationVisible: false, notificationFor: '' });
        }, 5000);
      }
    });
  }

  render() {
    const {
      loading,
      cardImage,
      isNotificationVisible,
      notificationFor,
      selectedPharmacy
    } = this.state;
    return (
      <div>
        {loading ? (
          <div className="loaderContainer">
            <img
              src="/content/images/loader/loading.gif"
              alt="loader"
              className="loaderImage"
            />
          </div>
        ) : (
          <div>
            <div className="CardMasheadDetails">
              <p className="card-masthead--image ">
                <img src={cardImage} alt="couponimage" />
              </p>
            </div>
            <div
              className={`coupon-notification ${
                !isNotificationVisible && 'hidden'
              }`}
              in={isNotificationVisible}
            >
              <div>
                <div
                  className={`notification-title ${
                    isNotificationVisible && 'active'
                  }`}
                >
                  {notificationFor === 'Email'
                    ? 'An Email has been sent with your savings card'
                    : 'Your savings card has been sent by text'}
                  .
                </div>
              </div>
            </div>
            <RxCardSendCoupon
              selectedPrice={selectedPharmacy}
              isRxCard={true}
              isFromDiscountPage={true}
              isFromPhysicalModal={false}
              showNotification={this.showNotification.bind(this)}
              buttonLocation={
                this.props.isFromPharmacists
                  ? 'pharmacists-popup'
                  : 'discount-pharmacy-card-popup'
              }
            />
          </div>
        )}
      </div>
    );
  }
}

RxCardPopup.propTypes = {
  selectedPharmacy: PropTypes.string,
  isFromPharmacists: PropTypes.bool
};

RxCardPopup.defaultProps = {
  selectedPharmacy: '',
  isFromPharmacists: false
};

export default RxCardPopup;
